<div class="dialog-container">
    <!-- Header -->
    <div class="dialog-header">
        <h4 class="dialog-heading">Move Show To Partner Group</h4>
        <button type="button" class="close-button" aria-label="Close" (click)="cancel()">
            <svg viewBox="0 0 26 24" aria-hidden="true">
                <path d="M25,0 L1,24 M1,0 L25,24"></path>
            </svg>
        </button>
    </div>

    <mat-dialog-content>
        <form class="dialog-body" (ngSubmit)="submit()">
            <!-- Show -->
            <div class="show-summary">
                <div class="show-summary__item">
                    <span class="show-summary__label">Show</span>
                    <span class="show-summary__title">{{ show.title }}</span>
                </div>
                <div class="show-summary__item">
                    <span class="show-summary__label">Currently in</span>
                    <span class="show-summary__group" [class.show-summary__group--none]="!currentPartnerGroupName">
                        {{ currentPartnerGroupName || 'No partner group' }}
                    </span>
                </div>
            </div>

            <!-- Partner group -->
            <app-select-search placeholder="Move to partner group" name="partnerGroup" [(ngModel)]="selectedPartnerGroupId">
                <app-select-item *ngFor="let group of partnerGroups; trackBy: trackById" [value]="group.id">{{ group.name }}</app-select-item>
            </app-select-search>
            <p *ngIf="errorMessage" class="form-error" role="alert">{{ errorMessage }}</p>

            <!-- Actions -->
            <div class="buttons">
                <button type="button" class="form-button form-button-cancel" (click)="cancel()">Cancel</button>
                <button type="submit" class="form-button" [disabled]="!canSubmit">{{ saving ? 'Moving...' : 'Move Show' }}</button>
            </div>
        </form>
    </mat-dialog-content>
</div>
